<template>
  <div class="infomation">
    <van-tabs
      v-model="active"
      title-active-color="#FF485D"
      title-inactive-color="#999AAA"
      swipe-threshold="3"
      swipeable
      animated
      sticky
      @click="tabClick"
    >
      <van-tab
        :title="item.name"
        v-for="(item,index) in list"
        :key="index"
      >
        <div class="container">
        <PullRefresh v-model="isLoading" @refresh="init">
          <Empty
            v-if="detail.totalCount === 0"
            tip="暂无内容"
          ></Empty>
          <van-list
            v-else
            :finished="detail.finished"
            v-model="detail.loading"
            loading-text="加载中..."
            @load="getDetail"
            offset="20"
          >
            <template #finished>
              <van-divider style="width:50%;margin:30px auto;">暂无更多</van-divider>
            </template>
            <ul class="list">
              <router-link
                v-for="(item,index) in detail.list"
                :key="index"
                :to="{name:'InfomationDetail',query:{id:item.id}}"
                tag="li"
                class="list_item"
              >
                <div class="left">
                  <div class="top">
                    <div class="title">{{ item.title }}</div>
                    <div class="text">{{ item.summary }}</div>
                  </div>
                  <div class="bottom">{{ item.createTime }}</div>
                </div>
                <div class="right">
                  <van-image class="img" :src="item.cover" fit="fill"></van-image>
                </div>
              </router-link>
            </ul>
          </van-list>
        </PullRefresh>
        </div>
      </van-tab>
    </van-tabs>

  </div>
</template>

<script>
import { Empty } from '@/components';
import { PullRefresh } from 'vant';
export default {
  props: {

  },
  components: {
    Empty,
    PullRefresh
  },
  data () {
    return {
      active: 0,
      list: [],
      detail: {
        finished: false,
        loading: false,
        list: [],
        totalCount: ''
      },
      isLoading: false,
      id: ''
    };
  },
  computed: {

  },
  watch: {
    active: {
      handler (newValue) {
        this.$router.replace({
          query: {
            active: newValue
          }
        });
        // this.init();
      }
    }
  },
  created () {

  },
  async mounted () {
    await this.getListDetail();
    const { $route } = this;
    this.active = $route.query.active * 1 || 0;
  },
  methods: {

    /* 初始化数据列表 */
    init () {
      this.detail = {
        finished: false,
        loading: true,
        list: [],
        totalCount: ''
      };
      this.getDetail();
      this.isLoading = false;
    },

    /* 获取tab栏列表 */
    getListDetail () {
      let { $http, list, id } = this;
      $http.get('search/consult/channel', {
        showLoading: true,
        loadingText: '加载中...'
      }).then((res) => {
        list = res.data || {};
        id = list[this.active].id;
        this.list = list;
        this.id = id;
      });
    },

    /* 获取详情数据列表 */
    getDetail () {

      const { $http, id, detail } = this;
      $http.get('search/consult', {
        params: {
          consultType: id
        }
      }).then((res) => {
        const { nextPage, totalCount, isHasNext, result } = res.data || {};

        detail.finished = !isHasNext;
        detail.list.push(...result);
        detail.pageNo = nextPage;
        detail.totalCount = totalCount;
        detail.loading = false;

        this.detail = detail;
      });

    },

    /* tab栏切换 */
    tabClick (name) {
      let { id, list } = this;
      id = list[name].id;
      this.id = id;

      this.init();
    }

  }
};
</script>

<style scoped lang="less">
 .infomation{
    min-height: calc(100vh - 96px);
    background-color: #fff;
    /deep/
    .van-tabs__wrap{
      .van-tab--active{
        span{
          font-weight: bold;
        }
      }
      .van-tabs__line{
        background: url('~@/assets/images/icon_tab_red.png') no-repeat center center;
        background-size: contain;
      }
    }
    .container{
      margin-top: 32px;
      width: 100%;
      .list{
        padding:0px 28px;
        width: 100%;
        flex-direction: column;
        display: flex;
        .list_item{
          display: flex;
          justify-content: space-between;

          .left{
            font-size: 24px;
            color: #999AAA;
            display: flex;
            flex-direction: column;
            width: 446px;
            justify-content: space-between;
            .top{
              .title{
                font-size: 30px;
                font-weight: bold;
                color: #333444;
                margin-bottom: 12px;
              }
              .text{
                font-size: 24px;
                color: #999AAA;
                .text-overflow();
              }
              .bottom{

              }
            }
          }
          .right{
            .img{
              width: 216px;
              height: 144px;
              border-radius: 8px;
              overflow: hidden;
            }
          }
          &:not(:last-child){
            margin-bottom: 60px;
          }
        }
      }
    }
 }
</style>
